import { render, staticRenderFns } from "./UiFormGroup.vue?vue&type=template&id=e1e1c01c&"
import script from "./UiFormGroup.vue?vue&type=script&lang=js&"
export * from "./UiFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports